<template>
	<div class="container">
		<div class="main">
			<div class="login-box flex flex-c">
				<div class="topTitle">登陆S学院管理后台</div>
				<div class="edit-main flex flex-c">
					<div class="inputbg flex">
						<img src="../assets/icon/yh.png" style="width: 16px;height: 16px;" />
						<input class="input" v-model="uname" placeholder="请输入用户名称" autocomplete="new-password">
					</div>
					<div class="inputbg flex" style="margin-top: 21px;">
						<img src="../assets/icon/mm.png" style="width: 16px;height: 16px;" />
						<input class="input" v-model="password" type="password" placeholder="请输入登录密码"
							autocomplete="new-password">
					</div>
					<el-button class="login-btn" @click="event().onLogin()">登录
					</el-button>
				</div>
			</div>
		</div>
		<!-- <el-dialog title="" :visible.sync="forgetShow">
			<div class="forshowbg">
				<div class="ysbg">
					<img src="../assets/ys.png" style="width: 40px;height: 40px;" />
				</div>
				<div class="tit">忘记密码？</div>
				<div class="des">请联系管理员重置密码</div>
				<div class="btns" @click="forgetShow = false">
					<div class="te">我知道了</div>
					<i class="el-icon-right" style="margin-left: 5px;"></i>
				</div>
			</div>
		</el-dialog> -->
	</div>
</template>

<script>
	import dialogCom from '../components/dialog.vue'
	import {
		encrypt
	} from "@/filters/filter";
	import {
		login,
		menulist,
		getCaptcha
	} from "@/api/common";
	import {
		pms2MenuList
	} from "../filters/filter";
	import Utils from "@/jslibs/utils";
	import {
		mapMutations,
		mapActions
	} from "vuex";
	// import { LimitsList } from '@/api/auth'
	export default {
		components: {
			dialogCom
		},
		data() {
			return {
				forgetShow: false,
				checked: false,
				code: "",
				inputCode: "",
				uname: "",
				password: "",
				rules: [],
				permissionList: [],
				operationList: [{
					name: "样例管理",
					operations: ["编辑", "删除", "导出"]
				}],
				menuList: [],
				noChildMunuList: ["酒店商品管理"] ,//mixin operation 记得也要改
				dialogTitle:'用户协议'
			};
		},

		created() {},

		mounted() {
			let loginAccount = localStorage.getItem('loginAccount')
			let loginPassword = localStorage.getItem('loginPassword')
			if (loginAccount && loginPassword) {
				this.uname = loginAccount
				this.password = loginPassword
				this.checked = true
			}
		},
		methods: {
			...mapMutations([
				"update_operation_list",
				"update_permission_list",
				"updateLoginData"
			]),
			...mapActions(["getCommonInfo"]),
			event() {
				const self = this;
				return {
					onVerifyImgClicked() {
						self.handler().refreshCode();
					},
					onLogin: () => {
						// Utils.setCookie("authorization", '123123', 7); // TODO: 先设三天过期
						// Utils.setCookie("adminName", 'admin', 7); // TODO: 先设三天过期  */
						// this.$router.push("/console");
						this.network().addlogin();
					}
				};
			},
			network() {
				return {
					/*  getListA() {}, */
					addlogin: async () => {
						if (!this.handler().verifyInput()) return;
						const {
							status,
							data
						} = await login({
							uname: this.uname,
							password: this.password,
							code: this.inputCode,
							code_key: this.code
						});
						if (this.checked) {
							localStorage.setItem('loginAccount', this.uname)
							localStorage.setItem('loginPassword', this.password)
						}
						Utils.setCookie("authorization", data.result.token, 7); // TODO: 先设三天过期
						Utils.setCookie("adminName", data.result.user.name, 7); // TODO: 先设三天过期  */
						sessionStorage.setItem("permission", JSON.stringify(data.result.user.menus_all));
						sessionStorage.setItem("menuIds", JSON.stringify(data.result.user.menus_all));
						this.$store.commit('updateLoginData',{
							...data.result.user
						})
						this.$router.push("/console");
						// this.handler().buildTree(data.result.user.menus);
					},
					getAdminAuthMenu: async () => {
						let postData = {
							page_size: 1000,
							page_index: 1,
							type: 1
						};
						const {
							status,
							data
						} = await menulist(postData);
						if (status !== 200) return;
						this.handler().buildTree(data.result.data);

					}
				};
			},

			handler() {
				const self = this;
				return {
					async refreshCode() {
						// eslint-disable-next-line no-undef
						const res = await getCaptcha();
						const img = document.getElementById("code");
						img.src = res.data.result.img;
						self.code = res.data.result.key;
					},
					verifyInput: () => {
						if (!this.uname || !this.uname.trim()) {
							this.$message({
								message: "请输入账号",
								type: "warning"
							});
							return false;
						}
						if (!this.password || !this.password.trim()) {
							this.$message({
								message: "请输入密码",
								type: "warning"
							});
							return false;
						}
						// if (!this.inputCode || !this.inputCode.trim()) {
						// 	this.$message({
						// 		message: "请输入验证码",
						// 		type: "warning"
						// 	});
						// 	return false;
						// }
						// if (this.code.toLowerCase() !== this.inputCode.toLowerCase()) {
						// 	this.$message({
						// 		message: "验证码错误",
						// 		type: "warning"
						// 	});
						// 	this.refreshCode();
						// 	return false;
						// }
						return true;
					},
					buildTree: tree => {
						this.permissionList = [];
						this.operationList = [];
						var permissionList = [];
						tree.forEach(item => {
							var permissionItem = {};
							permissionItem.name = item.menu_name;
							permissionItem.uuid = item.id;
							permissionItem.url = item.menu_url;
							var childrenList = [];
							if (item.son_rule && item.son_rule.length) {
								item.son_rule.forEach(two => {
									if (two.type != "3") {
										var permissiontwo = {};
										permissiontwo.name = two.menu_name;
										permissiontwo.uuid = two.id;
										permissiontwo.url = two.menu_url;
										childrenList.push(permissiontwo);
									} else {
										this.operationList.push(two);
									}

								})
							}
							permissionItem.children = childrenList;
							permissionList.push(permissionItem);
						})
						const jsonStrPer = JSON.stringify(permissionList);
						// // 对权限列表进行加密
						const encryptPer = encrypt(jsonStrPer).toString();
						sessionStorage.setItem("permission", jsonStrPer);
						// 存储有权限列表和操作列表到store
						this.update_permission_list(encryptPer);
						this.update_operation_list(this.operationList);
						//let menuList = pms2MenuList(this.permissionList);
						this.$router.push("/");
					}
				};
			}
		},
		watch: {},
		computed: {}
	};
</script>

<style scoped lang="less">
	.ygx {
		width: 16px;
		height: 16px;
		background: #FFFFFF;
		border: 1px solid #DEDEDE;
	}

	.title-box-login {
		width: 100%;
		text-align: center;
		margin-bottom: 84px;

		.title {
			font-family: Roboto, Roboto;
			font-weight: 500;
			font-size: 36px;
			color: #000000;
		}
	}

	.container {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100vh;

		.main {
			flex: 1;
			background-color: #fff;
			background-size: cover;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;

			.login-box {
				width: 420px;
				height: 532px;
				background: #F7F7F7;
				border-radius: 12px;
				padding: 20px 32px 65px 32px;
				box-shadow: 0px 13 51px 0px rgba(0,0,0,0.06);

				.topTitle {
					margin-top: 9px;
					font-family: SourceHanSansCN, SourceHanSansCN;
					font-weight: 500;
					font-size: 20px;
					color: #141414;
				}

				.img-wrap {
					width: 380px;
					height: 400px;

					img {
						width: 100%;
						height: 100%;
					}
				}

				.edit-main {
					margin-top: 42px;

					.inputbg {
						width: 356px;
						height: 56px;
						background: #FFFFFF;
						border-radius: 8px;
						padding: 22px 16px;
						border: 1px solid #DEDEDE;
					}

					.itemTitle {
						margin-bottom: 8px;
						font-family: Roboto, Roboto;
						font-weight: 400;
						font-size: 16px;
						color: #4B5563;
					}

					.input {
						padding: 0 14px;
						flex: 1;
						outline: none;
						border: none;
						font-size: 16px;
						background: transparent;
					}

					.input::placeholder {
						font-family: SourceHanSansCN, SourceHanSansCN;
						font-weight: 400;
						font-size: 16px;
						color: #9195A1;
					}

					.verify-box {
						position: relative;
						width: 396px;
						display: flex;
						align-items: center;

						.edit-box1 {
							display: flex;
							align-items: center;
							width: 260px;
							border: 1px solid #eaeaea;
							border-radius: 10px;
							padding: 17px 16px;

							.input {
								padding: 0 14px;
								flex: 1;
								outline: none;
								border: none;
								font-size: 16px;
								background: transparent;
							}
						}

						img#code.img-verify {
							float: left;
							width: 100px;
							height: 40px;
							margin-left: 20px;
						}
					}

					.login-btn {
						width: 356px;
						height: 56px;
						background: #7581ce;
						border-radius: 28px;
						margin-top: 68px;
						display: flex;
						align-items: center;
						justify-content: center;
						font-family: SourceHanSansCN, SourceHanSansCN;
						font-weight: 500;
						font-size: 18px;
						color: #FFFFFF;
					}
				}
			}
		}

		.foot {
			height: 54px;
			display: flex;
			padding: 27px 0 33px;
			font-size: 14px;
			flex-direction: column;
			align-items: center;

			p:first-child {
				margin: 0;
			}

			p:last-child {
				margin-top: 12px;
			}
		}
	}

	/deep/input:-internal-autofill-selected {
		background-color: none !important;
	}

	.tips {
		font-family: SourceHanSansCN, SourceHanSansCN;
		font-weight: 400;
		font-size: 14px;
		color: #9195A1;
		margin-left: 9px;
	}

	.forshowbg {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		width: 856px;
		height: 540px;
		background: #F7F7F2;
		box-shadow: inset 0px 0px 64px 0px rgba(230, 255, 79, 0.29);
		border-radius: 16px;
		border: 1px solid #F6FFB2;
	}

	.ysbg {
		background-color: rgba(64, 158, 255, 0.2);
		width: 80px;
		height: 80px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.tit {
		margin-top: 20px;
		font-size: 18px;
		color: #000;
		font-weight: bold;
	}

	.des {
		margin-top: 10px;
		font-size: 14px;
		color: #999;
	}

	.btns {
		display: flex;
		cursor: pointer;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 40px;
		background-color: #409eff;
		border-radius: 5px;
		font-size: 14px;
		color: #fff;
		margin-top: 30px;
	}
</style>